import styled from 'styled-components';

export const MainContainer = styled.div`
  & > div:first-child {
    margin-bottom: 24px;
    margin-top: 16px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  margin-top: 16px;
`;

export const InfoBlock = styled.div`
  margin-right: 48px;

  & > div:not(:last-child) {
    margin-bottom: 14px;
  }
`;

export const InfoElement = styled.div`
  display: flex;
  margin-right: 48px;
  margin-bottom: 14px;

  & > div:last-child {
    margin-left: 8px;
    word-break: break-word;
    max-width: 300px;
  }
`;

export const AddressWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 14px;
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  column-gap: 48px;
  width: fit-content;
  margin-top: 16px;
  margin-bottom: 10px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;
